import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private showAdminLayoutSubject = new BehaviorSubject<boolean>(true);
  showAdminLayout$ = this.showAdminLayoutSubject.asObservable();
  sidebarOpen = false;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // hide header and footer for theese:
      let show = !event.urlAfterRedirects.includes('orders/deliverynote') && !event.urlAfterRedirects.includes('reports/stockbalanceprint');
      this.toggleAdminLayout(show);
    });
  }

  toggleAdminLayout(show: boolean) {
    this.showAdminLayoutSubject.next(show);
    if (!show) {
      this.closeSidebar();
    }
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar() {
    this.sidebarOpen = false;
  }
}
